import axios from 'axios';
import { updateField, getField } from 'vuex-map-fields';

export default {
  namespaced: true,
  state: {
    zenvia: [],
  },
  getters: {
    getField,
  },
  actions: {
    async saveZenviaConfig({ commit }, data) {
      await axios.post(
        `${process.env.API_ROOT}/zenvia-config/`,
        { data },
        {
          headers: {
            'x-access-token': data.token,
          },
        },
      );
    },

    async getZenviaConfig({ commit }, obj) {
      const response = await axios.get(
        `${process.env.API_ROOT}/zenvia-config/${obj.companyId}`,
        {
          headers: {
            'x-access-token': obj.token,
          },
        },
      );
      return response.data;
    },

    async testZenviaConfig({ commit }, obj) {
      const response = await axios.post(
        `${process.env.API_ROOT}/zenvia-config-tests`,
        { obj },
        {
          headers: {
            'x-access-token': obj.token,
          },
        },
      );
      return response.data;
    },
  },
  mutations: {
    updateField,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/integrations/zenvia/index.js